import { FC } from "react";

import LogoBlack from "./logo-axl-black.svg";
import LogoWhite from "./logo-axl-white.svg";

type LogoProps = {
  theme?: "light" | "dark";
  width?: string | number;
  height?: string | number;
};

export const AccelLogo: FC<LogoProps> = ({
  theme = "light",
  width,
  height = 100,
}) =>
  theme === "light" ? (
    <img alt="" src={LogoWhite} width={width} height={height} />
  ) : (
    <img alt="" src={LogoBlack} width={width} height={height} />
  );
